var _rect, _line, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.114,
    y: 2.614,
    width: 15.771,
    height: 18.771,
    rx: 4.188,
    ry: 4.188,
    transform: "translate(24 24) rotate(180)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.156,
    y1: 8.106,
    x2: 12.156,
    y2: 16.776
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "8.057 11.242 12.156 7.142 16.266 11.252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.8de14ce70a59f03deca5cfecb47308b3.svg";
export { ForwardRef as ReactComponent };